<template>
  <div class="content">
    <el-scrollbar ref="scroll" class="scrollbar-wrapper" wrap-style="overflow-x:hidden;">
        <el-collapse v-model="activeNames">
            <el-collapse-item  v-for="(item,index) in cards" :key="item.iccid" :name="index">
                <div class="collapse-title" slot="title">
                    <el-row style="width:100%">
                        <el-col :span="10">
                            <span style="color:#1f2f3d;font-weight: 400;font-size: 18px;">ICCID： {{item.iccid}}</span>
                        </el-col>
                        <el-col :span="10">
                            <span v-if="!!item.targetIccid" style="color:#42b983;font-weight: 400;font-size: 18px;">目标ICCID： {{item.targetIccid}}</span>
                        </el-col>
                        <el-col :span="3">
                            <el-button type="primary" @click.stop="removeCard(item,index)">移除卡号</el-button>
                        </el-col>
                        <el-col :span="1" v-if="item.error">
                            <i style="font-size:24px;color:red;line-height:46px" class="el-icon-error"></i>
                        </el-col>
                    </el-row>
                </div>
                <el-table :data="item.orderItems" max-height="450"  ref="productTable"
                    @selection-change="(selections)=>{handleSelectionProductChange(selections,item)}" row-key="id">
                    <el-table-column type="selection" align="center" width="60px" reserve-selection></el-table-column>
                    <el-table-column prop="orderNum" label="订单号" align="center" ></el-table-column>
                    <el-table-column prop="productName" label="套餐名称" align="center" ></el-table-column>
                    <el-table-column prop="productStatus" label="套餐状态" align="center" ></el-table-column>
                    <el-table-column prop="expireTime" label="套餐过期时间" align="center" ></el-table-column>
                    <el-table-column prop="type" label="套餐类型" align="center"></el-table-column>
                </el-table>
                <el-form :model="item" :ref="'refundForm' + index"  label-width="160px" style="margin-top:20px">
                    <el-form-item label="代理商层级：">
                        <p>{{item.companyName}}</p>
                    </el-form-item>
                    <el-form-item label="目标ICCID：" prop="targetIccid" :rules="[{required: true, message: '目标ICCID不能为空', trigger: 'blur' }]">
                        <el-input v-model="item.targetIccid" placeholder="请输入目标ICCID" clearable style="width: 300px" @blur="handleTargetIccid(item)"/> 
                    </el-form-item>
                    <el-row style="width:100%">
                        <el-col :span="12">
                            <el-form-item label="源卡备注：">
                                <el-input v-model="item.remark" placeholder="请输入" clearable type="textarea" maxlength="300" show-word-limit
                                    style="width: 500px" :autosize="{ minRows: 3, maxRows: 3}" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="目标卡备注：">
                                <el-input v-model="item.targetRemark" placeholder="请输入" clearable type="textarea" maxlength="300" show-word-limit
                                    style="width: 500px" :autosize="{ minRows: 3, maxRows: 3}" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row style="width:100%">
                      <el-col :span="12">
                        <el-form-item label="源卡售后备注：">
                            <el-input v-model="item.saleRemark" placeholder="请输入" clearable type="textarea" maxlength="300" show-word-limit
                                style="width: 500px" :autosize="{ minRows: 3, maxRows: 3}" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="目标卡售后备注：">
                            <el-input v-model="item.targetSaleRemark" placeholder="请输入" clearable type="textarea" maxlength="300" show-word-limit
                                style="width: 500px" :autosize="{ minRows: 3, maxRows: 3}" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                </el-form>
            </el-collapse-item>
            <el-button style="width: 100%;" icon="el-icon-circle-plus-outline" @click="addCardShow = true"
			plain>添加卡号</el-button>
        </el-collapse>
    </el-scrollbar>
    <div class="foot">
        <el-button type="primary" @click="submitTransferProduct">开始批量转套餐</el-button>
    </div>

    <!-- 添加卡号 -->
    <el-dialog title="添加转套餐" :visible.sync="addCardShow" width="440px" append-to-body>
        <el-input v-model="iccid" placeholder="请输入卡号" clearable style="width: 240px" />
        <div class="dialog-footer" slot="footer">
            <el-button type="primary" @click="addOrderShow = false" plain>取消</el-button>
            <el-button type="primary" @click="submitCard">确定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import { transferProductList , batchTransferProduct} from "@/api/api.js";
export default {
  name: "transferProduct",
  data() {
    return {
      activeNames: [0],
      size: "medium",
      cards:[],
      addCardShow:false,
      iccid:undefined
    };
  },
  computed: {
    cardIccids(){
      return this.$store.state.cardProduct.iccids;
    },
  },
  methods: {
    initCards() {
        if(this.cardIccids){
            transferProductList(this.cardIccids).then(res=>{
                this.cards = res.data.data
            })
        }
    },
    // 选择套餐变化
    handleSelectionProductChange(selection,item) {
        item.selectOrderItems = selection.map(p=>p.orderNum);
        if(selection.length > 0 && !!item.targetIccid){
           this.$set(item,'error',false) 
        }else{
            this.$set(item,'error',true)
        }
    },
    handleTargetIccid(item){
        if(!!item.selectOrderItems && item.selectOrderItems.length >0 && !!item.targetIccid){
           this.$set(item,'error',false) 
        }else{
            this.$set(item,'error',true)
        }
    },
    removeCard(item,index){
        this.$confirm('确定移除卡号为'+item.iccid+'的记录？', '移除转套餐', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.cards.splice(index, 1)
        }).catch(() => {});
    },
    submitCard(){
        if(!this.iccid){
            this.$message({type: 'error',message: "请输入卡号"});
            return 
        }
        transferProductList(this.iccid).then(res=>{
            this.cards.push(res.data.data[0])
        })
    },
    submitTransferProduct(){
        let form = this.cards
        let flag = true
        form.forEach(item=>{
            if(!item.selectOrderItems){
                this.$set(item,'error',true)
                flag = false
            }
            if(!!item.selectOrderItems && item.selectOrderItems.length == 0){
                this.$set(item,'error',true)
                flag = false
            }
            if(!item.targetIccid){
                this.$set(item,'error',true)
                flag = false
            }
        })
        if(flag){
            //没有任何错误 提交数据
            batchTransferProduct(this.cards).then(res=>{
                const obj = { path: "/package/packageManage" };
                this.$tab.closeOpenPage(obj);
            })
        }
    }
  },
  created() {
    this.initCards()
  },
  mounted() {
  },
};
</script>
<style scoped lang="less">
.content{
    padding: 20px 30px;
    .collapse-title {
		flex: 1 0 90%;
		order: 1;
		display: flex;
		justify-content: space-between;
	}
    .foot {
		width: calc(100% - 200px);
		position: fixed;
		right: 0;
		bottom: 0;
		height: 60px;
		line-height: 60px;
		background-color: white;
		text-align: center;
		padding: 0 20px
	}
    .scrollbar-wrapper{
		height: calc(100vh - 170px);
		margin-bottom: 0!important;
		overflow-x: hidden;
	}
}
</style>